import { render, staticRenderFns } from "./CopyPriceList.vue?vue&type=template&id=5e772391"
import script from "./CopyPriceList.vue?vue&type=script&lang=js"
export * from "./CopyPriceList.vue?vue&type=script&lang=js"
import style0 from "./CopyPriceList.vue?vue&type=style&index=0&id=5e772391&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports